import { decode, ExtensionCodec } from '@msgpack/msgpack';

/**
 * Parse a MessagePack response into a JavaScript object
 * @param {Response} response The Response object containing MessagePack data
 */
export async function parseMsgpackResponse(response: Response): Promise<any> {
  const buffer = await response.arrayBuffer();

  const extensionCodec = new ExtensionCodec();

  // Handle ExtType objects for dates (type codes 1 and 2 based on eval_calculator implementation)
  // See: https://github.com/srpatx/eval_calculator/blob/4e5802863f7e7e6cbd1a6c87c7f2ba5088f871cf/eval_calculator/utils/msgpack_utils.py#L19
  extensionCodec.register({
    type: 1, // DATETIME_EXT
    encode: () => null,
    decode: (data) => new TextDecoder().decode(data),
  });

  extensionCodec.register({
    type: 2, // DATE_EXT
    encode: () => null,
    decode: (data) => new TextDecoder().decode(data),
  });

  const processExtTypes = (obj: any): any => {
    if (!obj) return obj;

    if (Array.isArray(obj)) {
      return obj.map((item) => processExtTypes(item));
    }

    if (typeof obj === 'object') {
      if (obj.type !== undefined && obj.data !== undefined) {
        return new TextDecoder().decode(obj.data);
      }

      const result: Record<string, any> = {};
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          result[key] = processExtTypes(obj[key]);
        }
      }
      return result;
    }

    return obj;
  };

  const decodedData = decode(new Uint8Array(buffer), { extensionCodec });
  return processExtTypes(decodedData);
}
